export const parsePaginatedResponse = (response) => {
  const payload = response?.data ?? response ?? {};

  if (Array.isArray(payload)) {
    return {
      results: payload,
      count: payload.length,
      next: null,
      previous: null,
    };
  }

  const results = Array.isArray(payload.results) ? payload.results : [];
  const meta = payload._meta ?? payload.meta ?? null;
  return {
    results,
    count: Number(payload.count ?? results.length),
    next: payload.next ?? null,
    previous: payload.previous ?? null,
    meta,
  };
};

export const getTotalPages = (count, pageSize) => {
  if (!pageSize) return 1;
  return Math.max(1, Math.ceil((Number(count) || 0) / pageSize));
};
